import { render, staticRenderFns } from "./mediaPlatformAccount.vue?vue&type=template&id=5bca5c8a&scoped=true&"
import script from "./mediaPlatformAccount.vue?vue&type=script&lang=js&"
export * from "./mediaPlatformAccount.vue?vue&type=script&lang=js&"
import style0 from "./mediaPlatformAccount.vue?vue&type=style&index=0&id=5bca5c8a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bca5c8a",
  null
  
)

component.options.__file = "mediaPlatformAccount.vue"
export default component.exports